import { storeToRefs } from 'pinia';

import { useBlockStore } from '../products/pha/modules/block/store';
import { groupAttributesByBlock } from '@/helpers/json-formatter';

const useBlockComposable = () => {
    const { block, blocks } = storeToRefs(useBlockStore());
    const { fetchAllBlocks, fetchBlockDetails } = useBlockStore();

    const getAllBlocks = async (shared, params) => {
        await fetchAllBlocks(shared, params);
    };

    const getBlockDetails = async (shared, id) => {
        // check if blocks has block, if yes then just return it
        const currBlock = blocks.value?.find((block) => block.id == id);
        if (currBlock) {
            block.value = currBlock;
        } else {
            block.value = await fetchBlockDetails(shared, id);
        }
    };

    const getAttributesGroupByBlock = () => {
        return groupAttributesByBlock(blocks.value);
    };

    const addUserProfileBlock = (attributes) => {
        blocks.value.push({
            id: null,
            name: 'User Profile Block',
            attributes: attributes,
        });
    };

    return {
        block,
        blocks,
        getAllBlocks,
        getBlockDetails,
        getAttributesGroupByBlock,
        addUserProfileBlock,
    };
};

export default useBlockComposable;
